import { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Download, ExternalLink } from 'lucide-react';
import { readData } from '@/firebase/database';

const SOCIAL_ICONS: Record<string, JSX.Element> = {
  github: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/></svg>,
  linkedin: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>,
  twitter: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/></svg>,
  x: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4l11.733 16h4.267l-11.733 -16h-4.267z"/><path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"/></svg>,
  facebook: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>,
  instagram: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>,
  youtube: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19.1c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.43z"/><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"/></svg>,
  dribbble: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"/></svg>,
  tiktok: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/></svg>,
  discord: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M18.8 4A19.6 19.6 0 0 0 14.2 3a14 14 0 0 0-.6 1.2 18.3 18.3 0 0 0-5.2 0A14 14 0 0 0 7.8 3a19.6 19.6 0 0 0-4.6 1c-3 4.3-3.8 8.5-3.4 12.6A19.7 19.7 0 0 0 5.8 20a14.5 14.5 0 0 0 1.2-2 12.8 12.8 0 0 1-2-.9l.5-.4a14 14 0 0 0 12 0l.5.4a12.8 12.8 0 0 1-2 .9 14.5 14.5 0 0 0 1.2 2 19.7 19.7 0 0 0 6-3.4c.5-4.8-.8-9-3.4-12.6zM8.3 14.7a1.7 1.7 0 0 1 0-3.4 1.7 1.7 0 0 1 0 3.4zm7.4 0a1.7 1.7 0 0 1 0-3.4 1.7 1.7 0 0 1 0 3.4z"/></svg>,
  telegram: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></svg>,
  whatsapp: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>,
  medium: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="2"/><path d="M7 7h4l3 8 3-8h4"/></svg>,
  behance: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12h8a4 4 0 1 0 0-8H1v8zm0 0h8a4 4 0 1 1 0 8H1v-8zm14 0h8"/><path d="M15 6h8M19 12a4 4 0 1 0 0-8"/></svg>,
  reddit: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="14" r="8"/><circle cx="8.5" cy="13" r="1"/><circle cx="15.5" cy="13" r="1"/><path d="M9 17c1 1 4 1 6 0"/><path d="M20 6a1.5 1.5 0 1 0-3 0"/><path d="M12 6V2"/></svg>,
  twitch: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"/></svg>,
  spotify: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 15c2-1 6-1 8 0M7 12c3-1 7-1 10 0M6 9c4-1 8-1 12 0"/></svg>,
  threads: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/><path d="M16.5 10.5c-1-3-3.5-4-5.5-3.5s-3 2-3 4 1.5 3.5 3 4c2 .5 4-.5 5-2"/></svg>,
};

const getGreeting = (): { text: string; emoji: string } => {
  const h = new Date().getHours();
  if (h >= 5 && h < 12) return { text: 'Good Morning', emoji: '☀️' };
  if (h >= 12 && h < 13) return { text: 'Good Noon', emoji: '🌤️' };
  if (h >= 13 && h < 17) return { text: 'Good Afternoon', emoji: '⛅' };
  if (h >= 17 && h < 21) return { text: 'Good Evening', emoji: '🌅' };
  if (h >= 21 && h < 23) return { text: 'Good Night', emoji: '🌙' };
  return { text: 'Sweet Dreams', emoji: '💤' };
};

const GreetingBadge = () => {
  const [greeting, setGreeting] = useState(getGreeting);
  useEffect(() => {
    const id = setInterval(() => setGreeting(getGreeting()), 60_000);
    return () => clearInterval(id);
  }, []);
  return (
    <motion.div
      animate={{ y: [0, 6, 0] }}
      transition={{ duration: 3.5, repeat: Infinity, delay: 0.5 }}
      className="absolute -top-3 -left-2 sm:-top-4 sm:-left-4 glass neon-border rounded-xl px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-mono"
    >
      <motion.span key={greeting.text} initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 4 }} transition={{ duration: 0.4 }}>
        <span className="mr-1">{greeting.emoji}</span> {greeting.text}
      </motion.span>
    </motion.div>
  );
};

const ParticleField = () => {
  const particles = Array.from({ length: 30 }, (_, i) => i);
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {particles.map((i) => (
        <div key={i} className="absolute w-px h-px rounded-full bg-foreground/20"
          style={{ left: `${Math.random() * 100}%`, top: `${Math.random() * 100}%`, animationDelay: `${Math.random() * 4}s`, animationDuration: `${3 + Math.random() * 4}s`, width: `${1 + Math.random() * 2}px`, height: `${1 + Math.random() * 2}px` }} />
      ))}
    </div>
  );
};

const Hero = () => {
  const [profile, setProfile] = useState<Record<string, unknown> | null>(null);
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);
  const [roleIndex, setRoleIndex] = useState(0);
  const [displayed, setDisplayed] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const typingRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [roles, setRoles] = useState<string[]>(['Full-Stack Developer', 'React Specialist', 'UI/UX Enthusiast']);
  const [socials, setSocials] = useState<{ platform: string; url: string }[]>([]);
  const [cvUrl, setCvUrl] = useState('');

  useEffect(() => {
    readData('profile').then((p) => {
      setProfile(p);
      setProfileLoaded(true);
      if (p?.roles) {
        const r = typeof p.roles === 'string' ? p.roles.split(',').map((s: string) => s.trim()) : Object.values(p.roles);
        if (r.length > 0) setRoles(r as string[]);
      } else if (p?.role) {
        setRoles([p.role as string]);
      }
      if (p?.socials) {
        const arr = Object.values(p.socials) as { platform: string; url: string }[];
        setSocials(arr);
      }
      if (p?.cvUrl) setCvUrl(p.cvUrl as string);
    });
  }, []);

  useEffect(() => {
    const currentRole = roles[roleIndex] || '';
    const speed = isDeleting ? 40 : 80;
    typingRef.current = setTimeout(() => {
      if (!isDeleting && displayed === currentRole) {
        setTimeout(() => setIsDeleting(true), 1800);
      } else if (isDeleting && displayed === '') {
        setIsDeleting(false);
        setRoleIndex((prev) => (prev + 1) % roles.length);
      } else {
        setDisplayed(isDeleting ? currentRole.substring(0, displayed.length - 1) : currentRole.substring(0, displayed.length + 1));
      }
    }, speed);
    return () => { if (typingRef.current) clearTimeout(typingRef.current); };
  }, [displayed, isDeleting, roleIndex, roles]);

  const scrollToAbout = () => document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center grid-bg overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,hsl(var(--primary)_/_0.03)_0%,transparent_70%)] pointer-events-none" />
      <ParticleField />

      <div className="container mx-auto px-4 sm:px-6 pt-20 pb-32 sm:pb-28 md:pb-20 grid lg:grid-cols-2 gap-8 lg:gap-16 items-center relative z-10">
        {/* Left — Role/Title */}
        <div className="order-2 lg:order-1 relative z-20">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }}>
            <p className="section-tag mb-2 text-xs sm:text-sm">
              <span className="text-muted-foreground mr-2">&lt;</span>Hello, World!<span className="text-muted-foreground ml-2">/&gt;</span>
            </p>
          </motion.div>

          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.35 }}
            className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-3 sm:mb-4">
            I'm <span className="gradient-text">{(profile?.name as string) || 'Mustakim'}</span>
          </motion.h1>

          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.5 }} className="flex items-center gap-2 mb-6 sm:mb-8">
            <span className="text-base sm:text-lg md:text-xl lg:text-2xl text-muted-foreground font-mono">
              &gt; <span className="text-foreground">{displayed}</span>
              <span className="cursor-blink text-primary">|</span>
            </span>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.65 }} className="flex flex-wrap gap-3 mb-8 sm:mb-10">
            <button onClick={() => document.querySelector('#projects')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-neon-solid flex items-center gap-2 text-xs sm:text-sm py-2.5 px-4 sm:py-3 sm:px-6">
              View My Work <ExternalLink size={14} />
            </button>
            {cvUrl ? (
              <a href={cvUrl} target="_blank" rel="noopener noreferrer" download
                className="btn-neon flex items-center gap-2 text-xs sm:text-sm py-2.5 px-4 sm:py-3 sm:px-6">
                <Download size={14} /> Download CV
              </a>
            ) : (
              <button className="btn-neon flex items-center gap-2 text-xs sm:text-sm py-2.5 px-4 sm:py-3 sm:px-6 opacity-50 cursor-not-allowed">
                <Download size={14} /> Download CV
              </button>
            )}
          </motion.div>

          {/* Stats */}
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.8 }} className="flex gap-6 sm:gap-8">
            {[
              { value: (profile?.yearsExperience as string) || '3+', label: 'Years Exp.' },
              { value: (profile?.projectsCompleted as string) || '50+', label: 'Projects' },
              { value: (profile?.clientsSatisfied as string) || '30+', label: 'Clients' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl sm:text-2xl font-display font-bold text-foreground">{stat.value}</div>
                <div className="text-[10px] sm:text-xs text-muted-foreground font-mono mt-1">{stat.label}</div>
              </div>
            ))}
          </motion.div>

          {/* Social Links — dynamic, with proper z-index and pointer-events */}
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6, delay: 0.95 }} className="flex gap-3 mt-6 sm:mt-8 relative z-30">
            {socials.length > 0 ? socials.map(({ platform, url }) => (
              <a key={platform} href={url} target="_blank" rel="noopener noreferrer"
                className="p-2 sm:p-2.5 rounded-lg border border-border hover:border-primary/40 text-muted-foreground hover:text-foreground transition-all duration-300 group cursor-pointer"
                style={{ pointerEvents: 'auto' }}
                aria-label={platform}>
                <span className="transition-transform duration-300 group-hover:scale-110 block">
                  {SOCIAL_ICONS[platform.toLowerCase()] || <span className="text-xs font-mono">{platform.slice(0, 2).toUpperCase()}</span>}
                </span>
              </a>
            )) : (
              [
                { key: 'github', icon: SOCIAL_ICONS.github },
                { key: 'linkedin', icon: SOCIAL_ICONS.linkedin },
                { key: 'twitter', icon: SOCIAL_ICONS.twitter },
              ].filter(s => profile?.[s.key]).map(({ key, icon }) => (
                <a key={key} href={(profile?.[key] as string) || '#'} target="_blank" rel="noopener noreferrer"
                  className="p-2 sm:p-2.5 rounded-lg border border-border hover:border-primary/40 text-muted-foreground hover:text-foreground transition-all duration-300 group cursor-pointer"
                  style={{ pointerEvents: 'auto' }}
                  aria-label={key}>
                  <span className="transition-transform duration-300 group-hover:scale-110 block">{icon}</span>
                </a>
              ))
            )}
          </motion.div>
        </div>

        {/* Profile Image */}
        <div className="order-1 lg:order-2 flex justify-center lg:justify-end relative z-10">
          <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.3 }} className="relative">
            <div className="absolute inset-0 rounded-full border border-primary/20 animate-spin-slow opacity-40" style={{ margin: '-16px' }} />
            <div className="absolute inset-0 rounded-full border border-primary/10 animate-pulse-glow" style={{ margin: '-8px' }} />

            <div className="relative w-48 h-48 sm:w-64 sm:h-64 md:w-72 md:h-72 lg:w-80 lg:h-80 rounded-full overflow-hidden neon-border animate-float">
              {(!profileLoaded || !imgLoaded) && (
                <div className="absolute inset-0 bg-muted animate-pulse rounded-full flex items-center justify-center">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 border-2 border-transparent border-t-primary rounded-full animate-spin" />
                </div>
              )}
              {profileLoaded && (
                <img src={(profile?.profileImage as string) || ''} alt={(profile?.name as string) || 'Developer'}
                  className={`w-full h-full object-cover transition-opacity duration-500 ${imgLoaded ? 'opacity-100' : 'opacity-0'}`}
                  loading="eager" onLoad={() => setImgLoaded(true)} onError={() => setImgLoaded(true)} />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent" />
            </div>

            <motion.div animate={{ y: [0, -6, 0] }} transition={{ duration: 3, repeat: Infinity, delay: 1 }}
              className="absolute -bottom-3 -right-2 sm:-bottom-4 sm:-right-4 glass neon-border rounded-xl px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-mono">
              <span className="text-primary">✓</span> Available for hire
            </motion.div>

            <GreetingBadge />
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.button
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5 }}
        onClick={scrollToAbout}
        className="absolute bottom-24 sm:bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-muted-foreground hover:text-foreground transition-colors duration-300 group z-20"
      >
        <span className="text-[10px] sm:text-xs font-mono tracking-widest uppercase">Scroll</span>
        <motion.div animate={{ y: [0, 6, 0] }} transition={{ duration: 1.5, repeat: Infinity }}>
          <ArrowDown size={14} className="sm:w-4 sm:h-4" />
        </motion.div>
      </motion.button>
    </section>
  );
};

export default Hero;
